var map = {
	"./big奖池底板.png": 15973,
	"./big底板.png": 437891,
	"./epic奖池底板.png": 251344,
	"./epic底板.png": 165018,
	"./epic箭头.png": 205329,
	"./grand奖池底板.png": 467593,
	"./grand底板.png": 252927,
	"./grand皇冠.png": 846754,
	"./huge奖池底板.png": 843234,
	"./huge底板.png": 812312,
	"./major奖池底板.png": 635756,
	"./major底板.png": 86030,
	"./major皇冠.png": 92175,
	"./massive奖池底板.png": 405321,
	"./massive底板.png": 310399,
	"./massive箭头.png": 632852,
	"./mini奖池底板.png": 669034,
	"./mini底板.png": 650560,
	"./mini皇冠.png": 395793,
	"./super奖池底板.png": 299286,
	"./super底板.png": 527636,
	"./super箭头.png": 824607,
	"./ultimate奖池底板.png": 144222,
	"./ultimate底板.png": 351196,
	"./ultimate箭头.png": 7687,
	"./win金币堆.png": 206051
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 676620;